import React from 'react';

import {Footer , Header , Skills , Education , Work } from './container';
import { Navbar } from './components';
import './App.scss';
const App = () => {
  return (
    <div className='app'>
      <Navbar/>
      <Header/>
      <Work/>
      <Skills/>
      <Education/>
      <Footer/>
    </div>
  );
}

export default App;